var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.682 2.008a.572.572 0 00-.66.469.574.574 0 00.465.665 2.84 2.84 0 011.85 1.176 2.89 2.89 0 01-.69 4.008 2.851 2.851 0 01-3.985-.694 2.892 2.892 0 01.221-3.585l.016.325a.572.572 0 101.142-.053l-.062-1.338a.856.856 0 00-.895-.822l-1.33.062a.574.574 0 00-.545.601.573.573 0 00.597.548l.154-.008a4.048 4.048 0 00-.232 4.933 3.992 3.992 0 005.577.972 4.047 4.047 0 00.966-5.611 3.973 3.973 0 00-2.589-1.648z"
  })));
}
export default SvgSmall;